import React from 'react';
import { BookOpen, Calendar, ShieldCheck, Star } from 'lucide-react';
export function WhatYouGetSection() {
  return <section className="py-20 bg-rose-50 px-4 sm:px-6 lg:px-8" data-id="element-145">
      <div className="max-w-7xl mx-auto" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-148">
            Disciplina Anti-Flojera: <br data-id="element-149" />
            <span className="text-rose-600" data-id="element-150">El Plan de 21 Días</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-151">
            No es solo un libro de rutinas. Es un manual de ingeniería mental
            para latinas ocupadas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-152">
          <div className="order-2 lg:order-1 space-y-8" data-id="element-153">
            <div className="flex gap-4" data-id="element-154">
              <div className="flex-shrink-0" data-id="element-155">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-md text-rose-600" data-id="element-156">
                  <BookOpen className="h-6 w-6" data-id="element-157" />
                </div>
              </div>
              <div data-id="element-158">
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-159">
                  Manual de Emergencia
                </h3>
                <p className="text-slate-600" data-id="element-160">
                  Para la mujer que perdió su chispa y quiere recuperarla.
                  Estrategias específicas para esos días donde "no tienes
                  ganas".
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-161">
              <div className="flex-shrink-0" data-id="element-162">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-md text-rose-600" data-id="element-163">
                  <Calendar className="h-6 w-6" data-id="element-164" />
                </div>
              </div>
              <div data-id="element-165">
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-166">
                  Plan de 21 Días
                </h3>
                <p className="text-slate-600" data-id="element-167">
                  3 semanas para reprogramar el interruptor de "flojera" de tu
                  cerebro. Convierte el movimiento en algo tan automático como
                  cepillarte los dientes.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-168">
              <div className="flex-shrink-0" data-id="element-169">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-md text-rose-600" data-id="element-170">
                  <ShieldCheck className="h-6 w-6" data-id="element-171" />
                </div>
              </div>
              <div data-id="element-172">
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-173">
                  Disciplina Real y Sostenible
                </h3>
                <p className="text-slate-600" data-id="element-174">
                  Sin dietas extremas, sin retos de 75 días imposibles. Un
                  sistema que se adapta a tu vida, no al revés.
                </p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-175">
            <div className="absolute inset-0 bg-rose-200 rounded-full filter blur-3xl opacity-30 animate-pulse" data-id="element-176"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2xjLH2ErdpHjNYGBG43wNj/Disciplina_Anti_Flojera.png" alt="Vista previa del contenido" className="relative mx-auto w-full max-w-md drop-shadow-2xl transform rotate-3 hover:rotate-0 transition-all duration-500" data-id="element-177" />
          </div>
        </div>
      </div>
    </section>;
}